import React, { useEffect, useState } from "react"
import ReactPlayerOG, { ReactPlayerProps } from "react-player"

export const ReactPlayer: React.FC<ReactPlayerProps> = (props) => {
	const [isVimeoReady, setVimeoReady] = useState(false)

	useEffect(() => {
		getVimeo().then(() => {
			setVimeoReady(true)
		}).catch()
	}, [])

	if (!isVimeoReady) return null
	return <ReactPlayerOG {...props} />
}

enum VimeoStatus {
	NOT_LOADED = 0,
	LOADING = 1,
	SUCCESS = 2,
	ERROR = 3,
}

function getVimeoStatus(): VimeoStatus {
	// @ts-ignore
	const savedStatus: VimeoStatus | null | undefined = window.VimeoStatus;

	return savedStatus ?? VimeoStatus.NOT_LOADED;
}

function setVimeoStatus(value: VimeoStatus) {
	// @ts-ignore
	window.VimeoStatus = value;
}

function getVimeo() {
	switch (getVimeoStatus()) {
		case VimeoStatus.LOADING:
			return new Promise<void>((resolve, reject) => {
				let wait = 10000;
				const interval = 500;

				let timerId: number;

				function tick() {
					wait -= interval;
					if (wait < 0) {
						window.clearInterval(timerId);
						return reject("Wait time ran out");
					}

					const s = getVimeoStatus();
					if (s === VimeoStatus.LOADING) return;

					window.clearInterval(timerId);
					if (s === VimeoStatus.ERROR) {
						return reject("Vimeo loading error");
					}
					return resolve();
				}

				timerId = window.setInterval(tick, interval);
			});
		case VimeoStatus.SUCCESS:
			return Promise.resolve();
		case VimeoStatus.ERROR:
			return Promise.reject("Vimeo loading error");
		default:
			return new Promise<void>((resolve, reject) => {
				setVimeoStatus(VimeoStatus.LOADING);

				const s = document.createElement("script");
				s.type = "text/javascript";
				s.async = true;

				// @ts-ignore
				const d = window.define;
				// @ts-ignore
				delete window.define;

				s.onload = () => {
					setVimeoStatus(VimeoStatus.SUCCESS);

					// @ts-ignore
					window.define = d;

					resolve();
				};

				s.onerror = (e) => {
					console.error("Could not fetch Vimeo");
					setVimeoStatus(VimeoStatus.ERROR);

					// @ts-ignore
					window.define = d;

					reject(e);
				};

				s.src = "https://player.vimeo.com/api/player.js";
				const b = document.getElementsByTagName("script")[0];
				b.parentNode.insertBefore(s, b);
			});
	}
}
